import React from 'react';

import FWorkbenchFilterBar, { FWorkbenchFilterField } from '../core/FWorkbenchFilterBar';
import { ComboRow } from '../core/coremodels';

type Props = {
  cycle: string;
  costcenter: string;
  axe: string;
  status: string;

  cycles: ComboRow[];
  costcenters: ComboRow[];
  axes: ComboRow[];
  statuses: ComboRow[];

  onCycleChange: (code: string) => void;
  onCostcenterChange: (code: string) => void;
  onAxeChange: (code: string) => void;
  onStatusChange: (code: string) => void;

  onRefresh: () => void;
  onClear: () => void;
  loading?: boolean;
};

class ActivityProgrammeFilterBar extends React.Component<Props> {
  onChange = (name: string, value: string) => {
    switch (name) {
      case 'cycle':
        this.props.onCycleChange(value);
        break;
      case 'costcenter':
        this.props.onCostcenterChange(value);
        break;
      case 'axe':
        this.props.onAxeChange(value);
        break;
      case 'status':
        this.props.onStatusChange(value);
        break;
      default:
        break;
    }
  };

  render() {
    const {
      cycle,
      costcenter,
      axe,
      status,
      cycles,
      costcenters,
      axes,
      statuses,
      onRefresh,
      onClear,
      loading,
    } = this.props;

    const fields: FWorkbenchFilterField[] = [
      { name: 'cycle', label: 'Cycle', items: cycles, width: 2 },
      { name: 'costcenter', label: 'Cost Center', items: costcenters, width: 3 },
      { name: 'axe', label: 'Axe', items: axes, width: 3 },
      { name: 'status', label: 'Status', items: statuses, width: 2 },
    ];

    return (
      <FWorkbenchFilterBar
        title="Programme Filters"
        subtitle="Filter the Activity Programme Review by cycle, responsible cost center, strategic axis and planning status."
        fields={fields}
        values={{ cycle, costcenter, axe, status }}
        onChange={this.onChange}
        onRefresh={onRefresh}
        onClear={onClear}
        loading={loading}
        refreshLabel="Refresh"
        clearLabel="Clear"
      />
    );
  }
}

export default ActivityProgrammeFilterBar;
